import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { Hotkey, Icon, Select } from '@gravity-ui/uikit';
import { cn } from '../../classname';
import { isFunction } from '../../lodash';
import './ToolbarSelect.css';
const b = cn('toolbar-select');
export const ToolbarSelect = ({ className, editor, focus, onClick, items, }) => {
    const activeItem = items.find((item) => item.isActive(editor));
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { size: "m", view: "clear", className: className, onOpenChange: () => {
                focus();
            }, value: activeItem ? [activeItem.id] : undefined, options: items.map((item) => ({
                data: item,
                value: item.id,
                text: isFunction(item.title) ? item.title() : item.title,
            })), renderOption: ({ text, data }) => {
                var _a;
                const { icon, hotkey, hint } = data;
                const hintText = isFunction(hint) ? hint() : hint;
                return (React.createElement("div", { "aria-label": text, className: b('item') },
                    React.createElement("div", { className: b('item-icon') },
                        React.createElement(Icon, { data: icon.data, size: Number((_a = icon.size) !== null && _a !== void 0 ? _a : 16) + 2 })),
                    React.createElement("div", { className: b('item-content') },
                        text,
                        React.createElement("div", { className: b('item-extra') },
                            hotkey && React.createElement(Hotkey, { value: hotkey }),
                            hintText && (React.createElement(HelpPopover, { content: hintText, className: b('item-hint') }))))));
            }, onUpdate: ([id]) => {
                var _a;
                (_a = items.find((item) => item.id === id)) === null || _a === void 0 ? void 0 : _a.exec(editor);
                onClick === null || onClick === void 0 ? void 0 : onClick(id);
                focus();
            } })));
};
